import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClientProvider } from "@tanstack/react-query";
import { inject } from "@vercel/analytics";
import { SpeedInsights } from "@vercel/speed-insights/react";
import App from "./App";
import { queryClient } from "./queries/queryClient";
import "./index.css";

inject();

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <SpeedInsights />
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
